import { Button } from "@/components/ui/button";
import { EnvelopeClosedIcon } from "@radix-ui/react-icons";

const emailCharCodes = [100, 97, 118, 105, 100, 64, 107, 97, 116, 97, 109, 97, 114, 105, 46, 115, 101];
const email = String.fromCharCode(...emailCharCodes);
const mailtoLink = `mailto:${email}`;

export default function BtnMail() {
    return (
        <Button variant="ghost" size="icon" asChild>
            <a href={mailtoLink} aria-label="Email David" className="flex items-center justify-center">
                <EnvelopeClosedIcon />
            </a>
        </Button>
    );
}